import { apiRoutes } from "@constants/api-routes";
import { POLICY_COMPONENT_ID_PATTERN } from "@constants/url-parameter-patterns";
import { RequestTypes } from "@enums/request-types";
import { PolicyComponent } from "@idw-types/data/reference-data/generic/policy-component";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequest } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";

type GetDeployedPolicyComponentRequestResponse = PolicyComponent;

export const getDeployedPolicyComponentRequest = async (
    id: string
): Promise<GenericNetworkResponse<GetDeployedPolicyComponentRequestResponse>> => {
    const route = injectCustomIdParameter(
        apiRoutes.serviceConfiguration.deployedPolicyComponentWithId,
        id,
        POLICY_COMPONENT_ID_PATTERN
    );


    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};